module.exports = __webpack_public_path__ + "static/media/震前有防災包的民眾在震後有無防災包.1a588b5d.png";